var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["carousel-slider/slider-arrow.j2"] = require( "carousel-slider/slider-arrow.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/slider-macros.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["nextAnalytics", "prevAnalytics", "classPrefix", "disablePrev", "disableNext", "arrowsOutside", "isSmallArrow"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("nextAnalytics", kwargs.hasOwnProperty("nextAnalytics") ? kwargs["nextAnalytics"] : "");
frame.set("prevAnalytics", kwargs.hasOwnProperty("prevAnalytics") ? kwargs["prevAnalytics"] : "");
frame.set("classPrefix", kwargs.hasOwnProperty("classPrefix") ? kwargs["classPrefix"] : "slider");
frame.set("disablePrev", kwargs.hasOwnProperty("disablePrev") ? kwargs["disablePrev"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("disableNext", kwargs.hasOwnProperty("disableNext") ? kwargs["disableNext"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("arrowsOutside", kwargs.hasOwnProperty("arrowsOutside") ? kwargs["arrowsOutside"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isSmallArrow", kwargs.hasOwnProperty("isSmallArrow") ? kwargs["isSmallArrow"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_2 = "";t_2 += "<button\n        class=\"o-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classPrefix"), env.opts.autoescape);
t_2 += "__button o-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classPrefix"), env.opts.autoescape);
t_2 += "__button-";
t_2 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "arrowsOutside")?"-outside":""), env.opts.autoescape);
t_2 += "-next js-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classPrefix"), env.opts.autoescape);
t_2 += "__button--next ";
t_2 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "disableNext")?"o-" + "" + runtime.contextOrFrameLookup(context, frame, "classPrefix") + "" + "__button--disabled":""), env.opts.autoescape);
t_2 += "\"\n        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nextAnalytics"), env.opts.autoescape);
t_2 += "\n        value=\"next\"\n        aria-label=\"";
t_2 += runtime.suppressValue((lineno = 20, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["slider_aria-label-next"])), env.opts.autoescape);
t_2 += "\"\n        data-qa-swiper-button-next\n    >\n\n        ";
env.getTemplate("carousel-slider/slider-arrow.j2", false, "core/templates/macros/slider-macros.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_2 += t_4
t_2 += "\n\n    </button>\n\n    <button\n        class=\"o-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classPrefix"), env.opts.autoescape);
t_2 += "__button o-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classPrefix"), env.opts.autoescape);
t_2 += "__button-";
t_2 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "arrowsOutside")?"-outside":""), env.opts.autoescape);
t_2 += "-prev js-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classPrefix"), env.opts.autoescape);
t_2 += "__button--prev ";
t_2 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "disablePrev")?"o-" + "" + runtime.contextOrFrameLookup(context, frame, "classPrefix") + "" + "__button--disabled":""), env.opts.autoescape);
t_2 += "\"\n        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "prevAnalytics"), env.opts.autoescape);
t_2 += "\n        value=\"previous\"\n        aria-label=\"";
t_2 += runtime.suppressValue((lineno = 32, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["slider_aria-label-previous"])), env.opts.autoescape);
t_2 += "\"\n        data-qa-swiper-button-prev\n    >\n\n        ";
env.getTemplate("carousel-slider/slider-arrow.j2", false, "core/templates/macros/slider-macros.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_2 += t_8
t_2 += "\n\n    </button>";
})})})});
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("create_slider_arrows");
context.setVariable("create_slider_arrows", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/slider-macros.j2"] , dependencies)